export default "__VITE_ASSET__CMTQKkb9__"